export const ellipsis = (content, maxLength = 100) => {
    return content.length > maxLength
        ? `${content.slice(0, maxLength)}...`
        : content;
};
// Solution from
// https://github.com/remarkjs/react-markdown/issues/785
const escapeBrackets = (text) => {
    const pattern = /(```[\S\s]*?```|`.*?`)|\\\[([\S\s]*?[^\\])\\]|\\\((.*?)\\\)/g;
    return text.replace(pattern, (match, codeBlock, squareBracket, roundBracket) => {
        if (codeBlock != null) {
            return codeBlock;
        }
        else if (squareBracket != null) {
            return `$$${squareBracket}$$`;
        }
        else if (roundBracket != null) {
            return `$${roundBracket}$`;
        }
        return match;
    });
};
const escapeMhchem = (text) => {
    return text.replaceAll("$\\ce{", "$\\\\ce{").replaceAll("$\\pu{", "$\\\\pu{");
};
export const preprocessLaTeX = (content) => {
    // Step 1: Protect code blocks
    const codeBlocks = [];
    content = content.replace(/(```[\s\S]*?```|`[^`\n]+`)/g, (_match, code) => {
        codeBlocks.push(code);
        return `<<CODE_BLOCK_${codeBlocks.length - 1}>>`;
    });
    // Step 2: Protect existing LaTeX expressions
    const latexExpressions = [];
    content = content.replace(/(\$\$[\s\S]*?\$\$|\\\[[\s\S]*?\\\]|\\\(.*?\\\))/g, (match) => {
        latexExpressions.push(match);
        return `<<LATEX_${latexExpressions.length - 1}>>`;
    });
    // Step 3: Escape dollar signs that are likely currency indicators
    content = content.replace(/\$(?=\d)/g, "\\$");
    // Step 4: Restore LaTeX expressions
    content = content.replace(/<<LATEX_(\d+)>>/g, (_, index) => latexExpressions[parseInt(index)]);
    // Step 5: Restore code blocks
    content = content.replace(/<<CODE_BLOCK_(\d+)>>/g, (_, index) => codeBlocks[parseInt(index)]);
    // Step 6: Apply additional escaping functions
    content = escapeBrackets(content);
    content = escapeMhchem(content);
    return content;
};
